module.exports = __webpack_public_path__ + "static/media/blob_2.81af160d.png";